module.exports = __webpack_public_path__ + "static/media/search-icon.97aab918.svg";